import { useId } from "react";

export function Stat({
  label,
  value,
  description,
  className = "",
}: {
  label: string;
  value: string;
  description: string;
  className?: string;
}) {
  const tooltipId = useId();

  return (
    <div className={`group relative min-w-[44px] ${className}`}>
      <button
        type="button"
        aria-describedby={tooltipId}
        onClick={(e) => {
          // Stat lives inside a clickable <summary>; don't let label clicks toggle the drawer.
          e.preventDefault();
          e.stopPropagation();
        }}
        className="block w-full cursor-help appearance-none rounded bg-transparent p-0 text-right text-[10px] font-semibold uppercase tracking-normal text-ink-500 focus:outline-none focus-visible:ring-1 focus-visible:ring-pitch-700"
      >
        {label}
      </button>
      <p className="text-sm font-semibold leading-tight text-ink-900">{value}</p>
      <span
        id={tooltipId}
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 z-20 mb-1 w-56 -translate-x-1/2 rounded bg-ink-900 px-2 py-1 text-left text-[11px] font-normal normal-case leading-snug tracking-normal text-white opacity-0 shadow-panel transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {description}
      </span>
    </div>
  );
}
